/**
 * Get unique pane key across all maps
 * @param mapKey {string}
 * @param layer {Object|string}
 * @param index {number}
 * @returns {string}
 */
var getKey = function getKey(mapKey, layer, index) {
  var layerKey = (layer === null || layer === void 0 ? void 0 : layer.key) || index || layer;
  return "".concat(mapKey, "-").concat(layerKey);
};
export default {
  getKey: getKey
};